import { Link } from "react-router-dom";
import {
  ArrowRight,
  TrendingDown,
  Zap,
  TrendingUp,
  Cog,
  Compass,
  Gauge,
  Sparkles,
  Brain,
  Cpu,
  Database,
  Workflow,
  ShieldCheck,
  LineChart,
  Users,
  Briefcase,
  Target,
} from "lucide-react";
import { site } from "../content/site";
import PageHero from "../components/PageHero";

const ICONS = {
  TrendingDown,
  Zap,
  TrendingUp,
  Cog,
  Compass,
  Gauge,
  Sparkles,
  Brain,
  Cpu,
  Database,
  Workflow,
  ShieldCheck,
  LineChart,
  Users,
  Briefcase,
  Target,
};

const Services = () => {
  const s = site.services;

  return (
    <>
      <PageHero eyebrow={s.eyebrow} title={s.title} intro={s.intro} />

      {/* WHAT WE DELIVER */}
      <section
        className="py-20 sm:py-24 border-b border-white/10 bg-[#5C0E45]/40"
        data-testid="services-deliverables"
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <p className="text-[10px] font-sans-modern uppercase tracking-[0.3em] text-white/55 mb-10">
            {s.deliverablesEyebrow}
          </p>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {s.deliverables.map((d, i) => {
              const Icon = ICONS[d.icon];
              return (
                <div
                  key={d.title}
                  data-testid={`services-deliverable-${i}`}
                  className="bg-[#711457] p-6 sm:p-8 min-h-[160px] flex flex-col justify-between"
                >
                  <div className="w-10 h-10 border border-white/25 flex items-center justify-center">
                    {Icon && (
                      <Icon size={18} className="text-white" strokeWidth={1.5} />
                    )}
                  </div>
                  <p className="mt-6 font-serif-display text-lg sm:text-xl text-white leading-tight">
                    {d.title}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CORE SERVICES — 12 cards */}
      <section
        className="py-24 sm:py-32 border-b border-white/10"
        data-testid="services-grid"
      >
        <div className="max-w-7xl mx-auto px-6 sm:px-8">
          <div className="max-w-3xl mb-16">
            <p className="text-[10px] font-sans-modern uppercase tracking-[0.3em] text-white/55 mb-6">
              {s.itemsEyebrow}
            </p>
            <h2 className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.05] tracking-tight">
              {s.itemsTitle}
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
            {s.items.map((item, i) => {
              const Icon = ICONS[item.icon];
              return (
                <article
                  key={item.title}
                  data-testid={`service-card-${i}`}
                  className="group relative bg-[#711457] p-8 sm:p-10 hover:bg-[#5C0E45] transition-colors duration-300 min-h-[320px] flex flex-col"
                >
                  <div className="mb-10">
                    <div className="w-12 h-12 border border-white/25 flex items-center justify-center group-hover:border-white/60 transition-colors">
                      {Icon && (
                        <Icon
                          size={20}
                          className="text-white/85 group-hover:text-white transition-colors"
                          strokeWidth={1.4}
                        />
                      )}
                    </div>
                  </div>
                  <h3 className="font-serif-display text-xl sm:text-2xl text-white leading-tight">
                    {item.title}
                  </h3>
                  <p className="mt-4 text-sm font-sans-modern font-light text-white/65 leading-relaxed">
                    {item.description}
                  </p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA + Location */}
      <section
        className="relative py-24 sm:py-32 border-b border-white/10 overflow-hidden"
        data-testid="services-cta-section"
      >
        <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
          <p className="font-serif-display text-3xl sm:text-4xl lg:text-5xl text-white leading-tight tracking-tight">
            Ready to scope an engagement?
          </p>
          <p className="mt-8 max-w-2xl mx-auto text-sm sm:text-base font-sans-modern text-white/65 leading-relaxed">
            {s.locationLine}
          </p>
          <Link
            to="/contact"
            data-testid="services-cta"
            className="mt-10 inline-flex items-center justify-center h-12 px-10 bg-white text-[#711457] font-sans-modern font-semibold text-sm tracking-wide hover:bg-white/90 transition-colors"
          >
            Begin a conversation
            <ArrowRight size={16} className="ml-2" />
          </Link>
        </div>
      </section>
    </>
  );
};

export default Services;
